import * as React from 'react';
import * as styles from './styles.css';

import Slider from 'react-slick';

import { RoundButton } from '@cian/ui-kit';

import { IconActionChevronRight16, IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';

import './slick/slick.css';
import './slick/slick-theme.css';

export const MyHomeWithSliderListing: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div data-testid="MyHomeWithSliderListing" className={styles['myhomewithsliderlisting-container']}>
      <Slider
        className="custom-slider"
        nextArrow={
          <div>
            <RoundButton title="" theme="fill_light" icon={<IconActionChevronRight16 />} />
          </div>
        }
        prevArrow={
          <div>
            <RoundButton title="" theme="fill_light" icon={<IconActionChevronLeft16 />} />
          </div>
        }
        autoplay={false}
        dots={false}
        infinite={false}
        slidesToShow={4}
        slidesToScroll={4}
      >
        {children}
      </Slider>
    </div>
  );
};

MyHomeWithSliderListing.displayName = 'MyHomeWithSliderListing';
